import React from "react"
import placeholder from "../../assets/img/company-logo-placeholder.png";
import "./UserAvatar.css"

function CollegeLogo(props) {
  return (
    <div className="college-logo-wrapper">
      <div
        className="college-logo-home"
      >
        <img
          src={props.icon || placeholder}
          // className="user-avatar-img"
          className="w-100"
          alt="company logo"
        />
        {props.children}
      </div>
    </div>
  )
}

export default CollegeLogo
